import React from 'react';

import { PageTitle } from '../../../components';
import { FAQs } from '../../../sections';
import { faqsContent } from '../../../constants';



const FaqPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'faqs'} page={'faqs'} />

      {/* FAQs Section */}
      <FAQs faqsContent={faqsContent} />

    </>
  );
};

export default FaqPage;